module.exports = __webpack_public_path__ + "img/transcript.83641a81.jpeg";